
//人员
import { framework_tool } from '../../../../tool'
let { ossFileUtils } = framework_tool
/**
 *
 * @param {*} self this对象
 * @param {*} param1 组件
 */
export const personDetailColumns = (self, [Alert, FormTable, WizAvatarUpload]) => {
  let userType = self._wizForm && self._wizForm.getFieldValue('userType') !== undefined ?
    self._wizForm.getFieldValue('userType') : self.initialValue.userType !== undefined ?
      self.initialValue.userType : 1;
  let idCardStr = userType === 1 || userType === 2 || userType === 5 ? "工号":"身份证号";

  return [{
    name: "id",
    formItem: {
      type: "hidden",
      initialValue: self.initialValue.id
    }
  },
  {
    name: "personId",
    formItem: {
      type: "hidden",
      initialValue: self.initialValue.personId
    }
  },
  {
    title: "账号",
    name: "userName",
    formItem: {
      disabled: self.pageType === 'upd',
      initialValue: self.initialValue.userName,
      rules: [{
        required: true,
        message: "请输入账号"
      },
      {
        pattern: /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
        message: "账号不能含有特殊字符"
      }
      ]
    },
    extra: self.pageType === 'add' ? Alert : undefined
  },
  {
    title: "姓名",
    name: "fullName",
    formItem: {
      initialValue: self.initialValue.fullName,
      rules: [{
        required: true,
        message: "请输入姓名"
      },
      {
        pattern: /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
        message: "姓名不能含有特殊字符"
      }
      ]
    }
  },
  {
    title: "用户属性",
    name: "userType",
    dict: [{
      code: 0,
      codeName: "学员"
    },
    {
      code: 1,
      codeName: "SGM总部"
    },
    {
      code: 2,
      codeName: "SGM区域"
    },
    {
      code: 3,
      codeName: "供应商"
    },
    {
      code: 5,
      codeName: "FSE"
    }
    ],
    formItem: {
      type: "select",
      rules: [{
        required: true,
        message: "请选择用户属性"
      }],
      initialValue: userType,
      onChange: (form, value) => {
        // 解决修改 用户类型 不会重新渲染问题
        self.setState({
          timestamp: new Date().getTime()
        })
      }
    }
  },
    {
      title: idCardStr,
      name: "idCard",
      formItem: {
        initialValue: self.initialValue.idCard,
        rules: [{
          required: true,
          message: "请输入" + idCardStr
        },
          userType === 1 || userType === 2 || userType === 5 ? {} : {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "身份证号不合法"
          }
        ]
      }
    },
  {
    title: "性别",
    name: "gender",
    dict: [{
      code: 0,
      codeName: "男"
    },
    {
      code: 1,
      codeName: "女"
    },
    {
      code: 2,
      codeName: "未知"
    }
    ],
    formItem: {
      type: "select",
      initialValue: self.initialValue.gender,
    }
  },
  {
    title: "手机号",
    name: "mobile",
    formItem: {
      initialValue: self.initialValue.mobile,
      rules: [ {
        pattern: /^(1)\d{10}$/,
        message: "手机号不合法"
      }]
    }
  },
  {
    title: "邮箱",
    name: "email",
    formItem: {
      initialValue: self.initialValue.email,
      rules: [{
        pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
        message: "邮箱不合法"
      }]
    }
  },
  {
    title: "地址",
    name: "address",
    formItem: {
      type: 'textarea',
      initialValue: self.initialValue.address,
      // rules: [{
      //   pattern: /.+?(省|市|自治区|自治州|县|区)/g,
      //   message: "地址不合法"
      // }]
    }
  },
  {
    title: "头像",
    name: "picture",
    formItem: {
      type: 'diy',
      diy: WizAvatarUpload,
      initialValue: (self.initialValue && self.initialValue.avatar) ? [
        { fileId: self.initialValue.avatar }
      ] : [],
    }
  },
  {
    title: "状态",
    name: "state",
    dict: [{
      code: 1,
      codeName: "激活"
    },
    {
      code: 0,
      codeName: "禁用"
    }
    ],
    formItem: {
      initialValue: (self.initialValue && self.initialValue.state === 0) ? self.initialValue.state : 1,
      type: "radio",
    }
  },
  {
    title: "任职信息",
    name: "userIdentityCmdList",
    formItem: {
      rules: [{
        required: true,
        message: "请选择任职信息"
      }],
      type: "diy",
      modal: true,
      initialValue: self.initialValue.userIdentityCmdList,
      diy: FormTable
    }
  },
  {
    title: "组织名称",
    name: "orgName",
    dataIndex: "orgName",
    tableItem: {}
  },
  {
    title: "岗位名称",
    name: "positionName",
    dataIndex: "positionName",
    tableItem: {}
  },
  {
    title: "任职状态",
    name: "jobState",
    dataIndex: "jobState",
    tableItem: {}
  },
  {
    title: "任职日期",
    name: "hireTime",
    dataIndex: "hireTime",
    tableItem: {}
  }
  ];
}
//任职
/**
 * 
 * @param {*} self 容器this
 * @param {*} other 其他参数
 */
export const servingColumns = (self, other = {}) => {
  let {
    record,
    WizTableForm,
    organizationConfig,
    onChangeRowMapForOrg,
    positionConfig,
    onChangeRowMapForPos,
    clearPositionForOrg,
    tableFormWillOpen,
    optionRender,
    selectDisabled,
  } = other
  return [
    {
      name: "id",
      formItem: {
        type: "hidden",
        initialValue: record.id
      }
    },
    {
      name: "orgId",
      formItem: {
        type: "hidden",
        initialValue: record.orgId
      }
    },
    {
      name: "positionId",
      formItem: {
        type: "hidden",
        initialValue: record.positionId
      }
    },
    {
      title: "组织名称",
      name: "orgName",
      dataIndex: "orgName",
      tableItem: {
        width: 200
      },
      formItem: {
        ...organizationConfig,
        key: 'organization' + record.orgId,
        initRows: [{ ...record, id: record.orgId, name: record.orgName }],
        initialValue: record.orgId,
        type: "diy",
        modal: true,
        rules: [{ required: true, message: '请选择组织机构' }],
        selectType: 'radio',
        diy: WizTableForm,
        onChangeRowMap: onChangeRowMapForOrg,
        disabled: selectDisabled
      }
    },
    {
      title: "岗位名称",
      name: "positionName",
      dataIndex: "positionName",
      tableItem: {
        width: 200
      },
      formItem: {
        ...WizTableForm.Config.positionName(),
        key: 'position' + record.positionId,
        initRows: [{ ...record, id: record.positionId, name: record.positionName }],
        initialValue: record.positionId,
        type: "diy",
        modal: true,
        rules: [{ required: true, message: '请选择岗位' }],
        selectType: 'radio',
        diy: WizTableForm,
        onChangeRowMap: onChangeRowMapForPos,
        onClearWiz: clearPositionForOrg,
        tableFormWillOpen,
        disabled: selectDisabled
      }
    },
    {
      title: "任职状态",
      name: "jobState",
      dataIndex: "jobState",
      tableItem: {
        width: 120
      },
      dict: [
        {
          code: 1,
          codeName: '在职'
        }, {
          code: 0,
          codeName: '离职'
        },
      ],
      formItem: {
        type: "radio",
        initialValue: record.jobState,
        rules: [{
          required: true,
          message: "请选择任职状态"
        }]
      }
    },
    {
      title: "生效时间",
      name: "hireTime",
      dataIndex: "hireTime",
      tableItem: {
        width: 150
      },
      formItem: {
        type: "datetime",
        initialValue: record.hireTime,
        format: 'YYYY-MM-DD HH:mm',
        rules: [{
          required: true,
          message: "请选择日期"
        }]
      }
    },
    {
      title: "最新修改时间",
      name: "updateTime",
      initialValue: record.updateTime,
      dataIndex: "updateTime",
      tableItem: self.isUpd ? {
        width: 150
      } : null
    },
    {
      title: "操作",
      tableItem: {
        width: 200,
        render: optionRender
      }
    }
  ]
};